export default {
  zh: {
    NO_AUTHENTICATION: '没有权限访问！',
    required: '请输入值！',
    inputRequired: '必填项！',
    filterNumRequired: '请使用"ADD"或"OR"拼接多个筛选条件！例如：(1 AND 2) OR (3 AND 4)！',
    nameRequired: '请输入名称！',
    fieldAndConditionRequired: '每个筛选条件的字段和条件均为必填项！',
    selectionRequired: '请选择至少一个字段用于显示！',
    oneFieldRequired: '至少有一个必填项缺少值！',
    assigneeRequired: '请分配一个负责人！',
    subjectRequired: '请添加一个主题！',
    dateRequired: '请选择一个日期！',
    statusRequired: '请选择一个状态！',
    priorityRequired: '请选择一个优先级！',
    returnDashboard: '返回Dashboard！',
    notFound: '404未找到此页面！',
    exceedMaximumLength: '至少一个字段超出长度要求！',
    fieldColRequired: '请先从左侧选择字段！',
    invoiceInfo: '必填项未添加！',
    secondaryInfo: '必填项未添加！',
    invalidData: '数据异常！',
    restrictedField: '受限字段',
    deletedField: '字段被删除',
    hasRestrictedField: '禁止点击字段为受限字段',
    hasDeletedValue: '禁止字段为被删除字段',
    invalidSelected: '请重新选择字段',
  },
  en: {
    NO_AUTHENTICATION: 'No authentication to access this page!',
    required: 'A value is required!',
    inputRequired: 'The input is required!',
    filterNumRequired: 'Please add Filter Criteria by using AND or OR for viewing condition! eg: (1 AND 2) OR (3 AND 4)',
    nameRequired: 'The name field is required!',
    fieldAndConditionRequired: '"Field" and "Condition" are required for every filter criterion! Please select a value for them',
    selectionRequired: 'Please select at least one field for display purpose!',
    oneFieldRequired: 'At least one required field is missing value!',
    assigneeRequired: 'Please choose an assignee!',
    subjectRequired: 'Please choose a subject!',
    dateRequired: 'Please choose a date!',
    statusRequired: 'Please choose a status!',
    priorityRequired: 'Please choose a priority!',
    returnDashboard: 'Return to Dashboard',
    notFound: '404 Page Not Found!',
    exceedMaximumLength: 'At least one field has exceeded maximum length!',
    fieldColRequired: 'Please select a field from left-hand side!',
    invoiceInfo: 'Required field is empty!',
    secondaryInfo: 'Required field is empty!',
    invalidData: 'Invalid data!',
    restrictedField: 'Restricted Field',
    deletedField: 'Deleted Field',
    hasRestrictedField: 'Disabled field has been restricted',
    hasDeletedValue: 'Disabled field has been deleted',
    invalidSelected: 'Please reselect the field',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/global/errors.js